// @mui
import { Grid, Pagination, Stack } from '@mui/material';
//
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import EmptyContent from '../../../components/EmptyContent';
import { SkeletonSolutionItem } from '../../../components/skeleton/SkeletonItem';
import useLocales from '../../../hooks/useLocales';
import { getQuestions, setQuestionSearch } from '../../../redux/slices/blog/blog.question';
import QuestionCard from './QuestionCard';
import QuestionHeaderToolbar from './QuestionHeaderToolbar';
import QuestionInfo from './QuestionInfo';
import QuestionNewForm from './QuestionNewForm';

// ----------------------------------------------------------------------

export default function QuestionSection() {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={12}>
        <QuestionInfo />
        <QuestionNewForm />
        <QuestionHeaderToolbar />
        <QuestionPosts />
      </Grid>
    </Grid>
  );
}

export function QuestionPosts() {
  const dispatch = useDispatch();
  const { translate } = useLocales();

  const { questions, search, totalPages, isLoading, numberOfElements } = useSelector((state) => state.blogQuestion);

  useEffect(() => {
    const timeout = setTimeout(() => {
      dispatch(getQuestions());
    }, 500);
    return () => clearTimeout(timeout);
  }, [search]);

  const handleChangePage = (_, page) => {
    dispatch(
      setQuestionSearch({
        ...search,
        page: page - 1,
      })
    );
  };

  return (
    <Stack spacing={3}>
      {questions.map((question) => (
        <QuestionCard key={question.id} question={question} />
      ))}
      {isLoading ? (<SkeletonSolutionItem />) : (
        numberOfElements == 0 && <EmptyContent description={translate('label.noSolution')} />
      )}
      {numberOfElements > 0 && <Stack alignItems={"center"} my={1.5}>
        <Pagination count={totalPages} variant='text' page={search.page + 1} onChange={handleChangePage} />
      </Stack>}
    </Stack>
  );
}